<template>
  <div>
    <!-- Phần giao diện -->
    <fieldset class="group-search">
      <div v-for="(item, index) in  items "
           :style="index === 0 ? 'border-bottom: none;' : 'border-top: 2px solid; margin-top: 20px;'">
        <b-field class="radio-checkbox group-search-content">
        <b-radio
          name="plate"
          v-model="item.isSearchAuction"
          :native-value="0"
          @input="handelChangeIsSearchAuction(index)"
        >
          Auction to Yard
        </b-radio>
        <b-radio
          name="plate"
          v-model="item.isSearchAuction"
          :native-value="1"
          @input="handelChangeIsSearchAuction(index)"
        >
          Yard to Yard
        </b-radio>
      </b-field>
        <b-field grouped
                 group-multiline
                 class="group-search-content columns">
          <span class="index">{{ index + 1 }}</span>
          <div class="control column is-2">
            <b-field :label="item.isSearchAuction === 0 ? 'オークション会場*'  : 'ヤード*'"
                     expanded
                     :type="item.errAuction">
             <b-autocomplete
                :data="filteredAuctionSiteList(index)"
                size="is-small"
                :field="items[index].isSearchAuction === 0 ? 'E_AuctionAreaSatellite.value' : 'AREA_NAME.value'"
                v-model="item.transportFromName"
                @select="setAuctionVendor($event, index)"
                @focus="handleAfterDelete"
                open-on-focus
                :placeholder="items[index].isSearchAuction === 0 ? 'Choose Auction Place' : 'Choose Yard'"
                clearable></b-autocomplete>
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="Yard City 1"
                     expanded>
                <b-autocomplete :data="filteredYardCity1List(index)"
                              size="is-small"
                              field="Yard_City_Name"
                              v-model="item.yardCity1"
                              @select="setYardCity1($event, index)"
                              @focus="handleAfterDelete"
                              :disabled="item.disableYardCity1"
                              open-on-focus
                              clearable></b-autocomplete>       
              <!-- <b-input size="is-small"
                       v-model="item.yardCity1"
                       :disabled="true" /> -->
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="納車先"
                     expanded>
              <b-input size="is-small"
                       v-model="item.transportToName"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="連絡先"
                     expanded>
              <b-input size="is-small"
                       v-model="item.transportToPhone"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="Default Handling Company (JP)"
                     expanded>
              <b-input size="is-small"
                       v-model="item.handlingCompanyJp"
                       :disabled="true" />
            </b-field>
          </div>

        </b-field>

        <b-field grouped
                 group-multiline
                 class="group-search-content columns">
          <div class="control column is-3">
            <b-field label="提携ヤード *"
                     :type="item.errYard">
              <b-autocomplete :data="filteredYardVendors(index)"
                              size="is-small"
                              field="AREA_NAME.value"
                              :value="item.transportToId"
                              v-model="item.transportToId"
                              @select="setYardName($event, index)"
                              @focus="handleAfterDelete"
                              placeholder="Choose Yard"
                              :disabled="item.disableYard"
                              open-on-focus
                              clearable>
              </b-autocomplete>
            </b-field>
          </div>

          <div class="control column is-3">
            <b-field label="住所">
              <b-input size="is-small"
                       v-model="item.transportFromAddress"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="担当者">
              <b-input size="is-small"
                       v-model="item.transportToIncharge"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="Default Handling Company (EN)">
              <b-input size="is-small"
                       v-model="item.handlingCompanyEn"
                       :disabled="true" />
            </b-field>
          </div>

        </b-field>
        <b-field grouped
                 group-multiline
                 class="group-search-content columns ">
          <div class="control column is-2">
            <b-field label="顧客ID"
                     :type="item.errCustomer"
                     :message="item.msgCustomer">
              <b-autocomplete :data="filteredCustomer(index)"
                              size="is-small"
                              field="customer_id_format"
                              :value="item.customerId"
                              v-model="item.customerId"
                              @select="setCustomerInf($event, index)"
                              placeholder="Choose CustomerId"
                              @input="validateCustomer(index)"
                              @focus="handleAfterDelete"
                              open-on-focus
                              clearable>
              </b-autocomplete>
            </b-field>
          </div>

          <div class="control column is-1">
            <b-field label="顧客名">
              <b-input size="is-small"
                       v-model="item.customerName"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-1">
            <b-field label="Grade">
              <b-input size="is-small"
                       v-model="item.customerGradeName"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="上乗せ金額">
              <b-input size="is-small"
                       v-model="item.customerGradeFeeAndPlace"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-2">
            <b-field label="Adjust fee ">
              <b-input size="is-small"
                       v-model="item.customerAdjustFee"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-1">
            <b-field label="請求金額">
              <b-input size="is-small"
                       :class="{ 'customs-price': item.checkPriceCustomer }"
                       v-model="item.customerTotalFee"
                       :disabled="true" />
            </b-field>
          </div>

          <div class="control column is-1">
            <b-button class="btn-search btn-edit-data"
                      :disabled="(item.customerId == '' || item.errCustomer != '' || !item.dataFee.basePriceFee)"
                      @click="openEditCustomerFeePopup(index)">
              料金更新
            </b-button>
          </div>

        </b-field>

        <b-field grouped
                 group-multiline
                 class="group-search-content group-button-search">
          <div class="control"
               style="display: flex; gap: 10px;">
            <b-button class="btn-search"
                      icon-left="search"
                      @click="searchDataAllFee(index)">
              料金検索
            </b-button>
            <b-button class="btn-search"
                      @click="clearDataField(index)">
              Clear
            </b-button>
          </div>
          <div class="control control-button-add"
               style="display: flex; gap: 10px;">
            <b-button @click="addFieldSearchFee(index)"
                      class="is-size-7"
                      icon-left="plus"
                      style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                background-color: #1d4cc7;
                color: #ffffff;
              ">
            </b-button>

            <b-button :disabled="items.length == 1"
                      @click="deleteDataByIndex(index)"
                      class="is-size-7"
                      style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                background-color: rgb(248, 40, 40);
                color: #ffffff;
              ">
              Delete
            </b-button>
          </div>

        </b-field>
        <div class="title-data-blank"
             style="text-align: center;"
             v-if="(!item.dataFee.basePriceFee) && item.checkDataBlank">
          <span>表示するデータはありません。</span>
        </div>
        <div class="recipe-price"  v-if="(item.dataFee.basePriceFee)">
          <p>顧客への請求額 ＝（ベースプライス＋グレードによる上乗せ金額ｘ{{item.isSearchAuction === 0 ? '会場' : 'ヤード'}}係数）ｘ(１＋ランク係数）+ADJUST FEE</p>
          <p>　　　利益　　 ＝ 顧客への請求額 － 発注先の陸送会社料金</p>
        </div>
        <div class="group-data-fee"
             v-if="(item.dataFee.basePriceFee)">
          <div class="fee-control inland-fee">
            <table>
              <thead>
                <tr>
                  <th>陸送会社</th>
                  <th>料金</th>
                  <th>最終更新日</th>
                  <th>履歴</th>
                  <th>料金更新</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="( data, indexCompany ) in  item.dataFee.inlandCompanyFee ">
                  <td> {{ data.company_name }}</td>
                  <td> {{ data.setting_fee | formatNumber }}</td>
                  <td> {{ data.update_date }}</td>
                  <td>
                    <button class="btn-history"
                            @click="openHistoryTransportsPopup(index, indexCompany)">
                      履歴
                    </button>
                  </td>
                  <td>
                    <button class="btn-show-popup"
                            @click="openEditCompanyFeePopup(index, indexCompany)">
                      料金更新
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="fee-control base-fee">
            <table>
              <thead>
                <tr>
                  <th>最安値</th>
                  <th>ベースプライス</th>
                  <th class="border-blank"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> {{ (item.dataFee.basePriceFee ? (formatNumber(item.dataFee.basePriceFee.setting_fee_company) | formatNumber) :
                    '')
                  }}</td>
                  <td :style="(item.dataFee.basePriceFee ? item.dataFee.basePriceFee.setting_fee : '') < (item.dataFee.basePriceFee ? (item.dataFee.basePriceFee.setting_fee_company) : '') ?
                      'background-color: red; font-weight: 600;' : 'background-color: transparent;'">
                    {{ (item.dataFee.basePriceFee ? (item.dataFee.basePriceFee.setting_fee | formatNumber) : '') }}
                  </td>
                  <td class="border-blank">
                    <button @click="openEditBaseFeePopup(index)">
                      料金更新
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="fee-control customer-fee">
            <div class="shipping-fee-place">
              <span>{{ item.transportFromName }} {{item.isSearchAuction === 0 ? '会場' : 'ヤード'}}係数 : {{ item.shippingFeeCoefficient }} </span>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Grade</th>
                  <th>ランク係数</th>
                  <th>上乗せ金額</th>
                  <th>請求金額</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for=" data  in  item.dataFee.listGrade ">
                  <td> {{ data.gradeName }}</td>
                  <td>{{ data.factorRank }} %</td>
                  <td> {{ (formatNumber(data.gradeFee  * item.shippingFeeCoefficient)) | formatNumber }} ({{ data.gradeFee | formatNumber }}) </td>
                  <td :style="((data.gradeFee + (item.dataFee.basePriceFee ? item.dataFee.basePriceFee.setting_fee : 0) +
                    (item.dataFee.customerPriceFee ? item.dataFee.customerPriceFee.setting_profit : 0)) <
                    (item.dataFee.basePriceFee ? (item.dataFee.basePriceFee.setting_fee_company) :
                      ''))
                    ? 'background-color: red; font-weight: 600;' : 'background-color: transparent;'">
                    {{ (formatNumber( (item.dataFee.basePriceFee ? (item.dataFee.basePriceFee.setting_fee + (data.gradeFee  * item.shippingFeeCoefficient)) * (1+data.factorRank/100) : 0) +
                      (item.dataFee.customerPriceFee ? item.dataFee.customerPriceFee.setting_profit : 0))) | formatNumber }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </fieldset>
  </div>
</template>

<script>
const regexFormatNumber = /^[0-9]+$/;
import jcPackage from '@/repositories/jcPackage';
import EditCompanyFeePopup from '@/components/EditCompanyFeePopup';
import EditBasePriceFeePopup from '@/components/EditBasePriceFeePopup';
import EditCustomerFeePopup from '@/components/EditCustomerFeePopup'
import HistoryTransportPopup from '@/components/HistoryTransportPopup';
import _debounce from 'lodash/debounce';
const editCompanyFeePopup = {
  component: EditCompanyFeePopup,
  hasModalCard: true,
  trapFocus: true,
};
const editBasePriceFeePopup = {
  component: EditBasePriceFeePopup,
  hasModalCard: true,
  trapFocus: true,
};
const editCustomerFeePopup = {
  component: EditCustomerFeePopup,
  hasModalCard: true,
  trapFocus: true,
};
const historyTransportPopup = {
  component: HistoryTransportPopup,
  hasModalCard: true,
  trapFocus: true,
};
export default {
  data: () => ({
    items: [
      {
        transportFromName: '',
        transportToId: '',
        transportToName: '',
        yardCity1: '',
        transportToPhone: '',
        handlingCompanyJp: '',
        handlingCompanyEn: '',
        transportFromAddress: '',
        transportToIncharge: '',
        customerId: '',
        customerIdSearch: '',
        customerName: '',
        customerGradeName: '',
        customerGradeFee: '',
        customerAdjustFee: '',
        customerTotalFee: '',
        placeId: '',
        satelliteId: '',
        yardId: '',
        errCustomer: '',
        msgCustomer: '',
        errAuction: '',
        msgAuction: '',
        errYard: '',
        msgYard: '',
        dataFee: {},
        checkDataBlank: false,
        checkPriceCustomer: false,
        disableYardCity1: false,
        disableYard: false,
        factorRank: 1,
        shippingFeeCoefficient: 1,
        customerGradeFeeAndPlace: '',
        isSearchAuction: 0
      }
    ],
    auctions: [],
    yards: [],
    listCustomerInf: [],
    listYardCity1: [],
    dataItem: {
      transportFromId: '',
      transportFromName: '',
      transportToId: '',
      transportToName: '',
      yardCity1: '',
      transportToPhone: '',
      handlingCompanyJp: '',
      handlingCompanyEn: '',
      transportFromAddress: '',
      transportToIncharge: '',
      customerId: '',
      customerIdSearch: '',
      customerName: '',
      customerGradeName: '',
      customerGradeFee: '',
      customerAdjustFee: '',
      customerTotalFee: '',
      placeId: '',
      satelliteId: '',
      yardId: '',
      errCustomer: '',
      msgCustomer: '',
      errAuction: '',
      msgAuction: '',
      errYard: '',
      msgYard: '',
      dataFee: {},
      checkDataBlank: false,
      checkPriceCustomer: false,
      disableYardCity1: false,
      disableYard: false,
      factorRank: 0,
      shippingFeeCoefficient: 1,
      customerGradeFeeAndPlace: ''
    },
    isDelete: false
  }),
  async created() {
    this.init();
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.commit('isLoadingApi', true);
      await this.$store.dispatch('fetchBookedItems');
      let debounce = _debounce(this.filter, 1000);
      this.auctions = this.$store.state.auctionVendors;
      this.yards = this.$store.state.yardVendors;
      this.listCustomerInf = this.$store.state.listCustomerInf;

      // tạo list yardCity1 không trùng nhau
      this.yards.forEach((item) => {
        const existingItem = this.listYardCity1.find((x) => x.Yard_City == item.Yard_City.value);
        if (!existingItem) {
          let data = {
            Yard_City: item.Yard_City.value,
            Yard_City_Name : item.Yard_City_Name.value
          }
          this.listYardCity1.push(data);
        }
      });
      this.listYardCity1.sort((a, b) => a.Yard_City_Name.localeCompare(b.Yard_City_Name));
      
      let placeIdEs = localStorage.getItem('placeIdEs');
      let satelliteIdEs = localStorage.getItem('satelliteIdEs');
      let yardIdEs = localStorage.getItem('yardIdEs');
      let customerIdSearchEs = localStorage.getItem('customerIdSearchEs');
      let auction = [];
      let yard = [];
      let customer = [];
      if (placeIdEs > 0) {
        if(satelliteIdEs > 0) {
          auction = this.auctions.filter(res => res.PlaceId.value == placeIdEs && res.PlaceSatelliteId.value == satelliteIdEs)
        }else{
          auction = this.auctions.filter(res => res.PlaceId.value == placeIdEs && (res.PlaceSatelliteId.value == '' || res.PlaceSatelliteId.value == '-1' ))
        }
        if(auction.length > 0){
          this.setAuctionVendor(auction[0],0);
        }
      }
      if(yardIdEs > 0) {
        yard = this.yards.filter(res => res.Yard_Record_Id.value == yardIdEs);
        if(yard.length > 0){
            this.setYardName(yard[0],0);
        }
      }

      if(customerIdSearchEs){
        customer = this.listCustomerInf.filter(res => res.customer_id_format == customerIdSearchEs);
        this.setCustomerInf(customer[0],0);
      }
      if(auction.length > 0 && yard.length > 0){
        this.searchDataAllFee(0);
      }
      localStorage.removeItem('placeIdEs');
      localStorage.removeItem('satelliteIdEs');
      localStorage.removeItem('yardIdEs');
      localStorage.removeItem('customerIdSearchEs');
      this.$store.commit('isLoadingApi', false);
    },
    handelChangeIsSearchAuction(index) {
      this.clearDataField(index)
    },
    filter() {
      this.auctions = this.$store.state.auctionVendors;
      this.yards = this.$store.state.yardVendors;
      this.listCustomerInf = this.$store.state.listCustomerInf;
    },
    setAuctionVendor(auction, index) {
      if (this.isDelete) return;

      const isAuctionPlace = this.items[index].isSearchAuction === 0;

      if (auction) {
        if (isAuctionPlace) {
          // Mapping cho Auction Place
          this.items[index].transportFromId = auction.AA_ID.value || '';
          this.items[index].transportFromName = auction.AuctionAreaSatellite.value || '';
          this.items[index].placeId = auction.PlaceId.value || null;
          this.items[index].satelliteId = auction.PlaceSatelliteId.value || -1;
          this.items[index].shippingFeeCoefficient = auction.shippingFeeCoefficient.value || 1;
        } else {
          this.items[index].transportFromId = auction.Yard_Record_Id.value || '';
          this.items[index].transportFromName = auction.AREA_NAME.value || '';
          this.items[index].placeId = auction.Big_Area.value || null;
          this.items[index].satelliteId = -1;
          this.items[index].shippingFeeCoefficient = 1;
        }
        this.items[index].dataFee = {};
        this.items[index].checkDataBlank = false;
        this.items[index].checkPriceCustomer = false;
        this.items[index].errAuction = '';
      } else {
        this.items[index].transportFromId = '';
        this.items[index].transportFromName = '';
        this.items[index].placeId = null;
        this.items[index].satelliteId = null;
        this.items[index].shippingFeeCoefficient = 1;
      }
    },

    // setAuctionVendor(auction, index) {
    //   if (!this.isDelete) {
    //     this.items[index].transportFromId = auction ? auction.AA_ID.value : '';
    //     this.items[index].transportFromName = auction
    //       ? auction.AuctionAreaSatellite.value
    //       : '';
    //     this.items[index].placeId = auction ? auction.PlaceId.value : null;
    //     this.items[index].satelliteId = auction ? (auction.PlaceSatelliteId.value ? auction.PlaceSatelliteId.value : -1) : null;
    //     this.items[index].dataFee = {};
    //     this.items[index].checkDataBlank = false;
    //     this.items[index].checkPriceCustomer = false;
    //     this.items[index].shippingFeeCoefficient = auction ? auction.shippingFeeCoefficient.value : 1;
    //     if (auction) {
    //       this.items[index].errAuction = ''
    //     }
    //   }
    // },
    setYardName(yard, index) {
      if (!this.isDelete) {
        this.items[index].transportToId = yard ? yard.AREA_NAME.value : '';
        this.items[index].transportToName = yard ? yard.YardName.value : '';
        this.items[index].yardId = yard ? yard.Yard_City.value : '';
        this.items[index].yardCity1 = yard ? yard.Yard_City_Name.value : '';
        this.items[index].transportToPhone = yard ? yard.Telephone.value : '';
        this.items[index].transportToIncharge = yard ? yard.Incharge.value : '';
        this.items[index].handlingCompanyEn = yard ? yard.handling_company_en.value : '';
        this.items[index].handlingCompanyJp = yard ? yard.handling_company_jp.value : '';
        this.items[index].dataFee = {};
        this.items[index].checkDataBlank = false;
        this.items[index].checkPriceCustomer = false;
        if (yard) {
          this.items[index].errYard = '';
          this.items[index].disableYardCity1 = true;
        }else{
          this.items[index].disableYardCity1 = false;
        }
      }
    },
    setCustomerInf(customer, index) {
      if (!this.isDelete) {
        this.items[index].customerId = customer ? customer.customer_id_format : '';
        this.items[index].customerName = customer ? customer.customer_name : '';
        this.items[index].customerGradeName = customer ? customer.trnsprtgrd : '';
        this.items[index].customerGradeFee = customer ? customer.grade_fee : '';
        this.items[index].customerIdSearch = customer ? customer.customer_id : '';
        this.items[index].customerTotalFee = '';
        this.items[index].customerAdjustFee = '';
        this.items[index].dataFee = {};
        this.items[index].checkDataBlank = false;
        this.items[index].checkPriceCustomer = false;
        this.items[index].factorRank = customer ? customer.factor_rank : 0;
        if (this.items[index].customerId && this.items[index].yardId && this.items[index].placeId && this.items[index].errCustomer == '') {
          let data = {
            auctionPlaceId: this.items[index].isSearchAuction === 0 ? this.items[index].placeId : this.items[index].transportFromId,
            satelliteId: this.items[index].satelliteId,
            yardRecordId: this.items[index].yardId,
            customerId: this.items[index].customerIdSearch,
            isSearchAuction: this.items[index].isSearchAuction
          }
          this.getDataFeeByCustomer(index, data);
        }
      }
    },
    setYardCity1(yard, index) {
      if (!this.isDelete) {
        this.items[index].yardId = yard ? yard.Yard_City : '';
        this.items[index].yardCity1 = yard ? yard.Yard_City_Name : '';
        if (yard) {
          this.items[index].disableYard = true;
          this.items[index].errYard = '';
        }else{
          this.items[index].disableYard = false;
        }
      }
    },
    isObjectEmpty(obj) {
      return Object.keys(obj).length == 0;
    },
    searchDataAllFee(index) {
      if (this.items[index].transportFromName == '') {
        this.items[index].errAuction = 'is-danger'
      } else {
        this.items[index].errAuction = '';
      }
      if(!this.items[index].yardId){
        if (this.items[index].transportToId == '') {
          this.items[index].errYard = 'is-danger'
        } else {
          this.items[index].errYard = '';
        }
      }
      
      if (this.items[index].yardId && this.items[index].placeId && this.items[index].errCustomer == '') {
        let data = {
          auctionPlaceId: this.items[index].isSearchAuction === 0 ? this.items[index].placeId : this.items[index].transportFromId,
          satelliteId: this.items[index].satelliteId,
          yardRecordId: this.items[index].yardId,
          customerId: this.items[index].customerIdSearch,
          isSearchAuction: this.items[index].isSearchAuction
        }
        this.getListDataFee(index, data);
      } else {
        this.items[index].dataFee = {};
      }
    },
    addFieldSearchFee(index) {
      const newItem = { ...this.dataItem };
      this.items.push(newItem);
    },
    deleteDataByIndex(index) {
      this.items.splice(index, 1);
      this.isDelete = true;
      if (this.items.length == 0) {
        this.addFieldSearchFee(1);
      }
    },
    handleAfterDelete() {
      this.isDelete = false;
    },
    validateCustomer(index) {
      if (!this.isDelete) {
        this.items[index].dataFee = {};
        if (this.items[index].customerId == '') {
          this.items[index].errCustomer = '';
          this.items[index].msgCustomer = '';
          return;
        }
        let customerIdFormat = '';
        this.listCustomerInf.find((v) => {
          if (v.customer_id_format == this.items[index].customerId) {
            customerIdFormat = v.customer_id_format;
          }
        });
        if (
          !regexFormatNumber.test(this.items[index].customerId) ||
          customerIdFormat == ''
        ) {
          this.items[index].errCustomer = 'is-danger';
          this.items[index].msgCustomer =
            '入力された顧客IDが存在しません。正しい顧客IDを入力してください。';
          return;
        }
        this.items[index].errCustomer = '';
        this.items[index].msgCustomer = '';
      }
    },
    getDataFeeByCustomer(index, data) {
      jcPackage
        .getFeeByCustomer(
          this.$store.state.accessTokenJPC,
          data
        )
        .then((rs) => {
          if (rs.data) {
            if (rs.data.basePrice) {
              this.items[index].customerTotalFee = (rs.data.basePrice.setting_fee + (this.items[index].customerGradeFee * this.items[index].shippingFeeCoefficient)) *(1 + this.items[index].factorRank/100);
              this.items[index].customerGradeFeeAndPlace = this.items[index].customerGradeFee * this.items[index].shippingFeeCoefficient;
              this.items[index].customerAdjustFee = 0;
              if (rs.data.customerPrice) {
                this.items[index].customerAdjustFee = rs.data.customerPrice.setting_profit;
                this.items[index].customerTotalFee += rs.data.customerPrice.setting_profit;

              }
            }
          }
        });
    },
    getListDataFee(index, data) {
      jcPackage
        .getListCompanyFee(
          this.$store.state.accessTokenJPC,
          data
        )
        .then((rs) => {
          if (rs.data) {
            this.items[index].dataFee = rs.data;
            this.items[index].checkDataBlank = false;
            if (this.items[index].customerId && this.items[index].errCustomer == '') {
              if (rs.data.basePriceFee) {
                this.items[index].customerTotalFee = (rs.data.basePriceFee.setting_fee + (this.items[index].customerGradeFee * this.items[index].shippingFeeCoefficient)) *(1 + this.items[index].factorRank/100);
                this.items[index].customerAdjustFee = 0;
                this.items[index].customerGradeFeeAndPlace = this.items[index].customerGradeFee * this.items[index].shippingFeeCoefficient;
                if (rs.data.customerPriceFee) {
                  this.items[index].customerAdjustFee = rs.data.customerPriceFee.setting_profit;
                  this.items[index].customerTotalFee += rs.data.customerPriceFee.setting_profit;
                }
                if (this.items[index].customerTotalFee < rs.data.basePriceFee.setting_fee_company) {
                  this.items[index].checkPriceCustomer = true;
                } else {
                  this.items[index].checkPriceCustomer = false;
                }
              }
            }
            if (!rs.data.basePriceFee) {
              this.items[index].checkDataBlank = true;
            }
          }
        });
    },
    openEditCompanyFeePopup(index, indexCompany) {
      const modal = this.$buefy.modal.open({
        ...editCompanyFeePopup,
        props: {
          item: this.items[index],
          indexCompany: indexCompany,
          token: this.$store.state.accessTokenJPC
        }
      });
      modal.$on('close', () => this.searchDataAllFee(index))
    },
    openHistoryTransportsPopup(index, indexCompany) {
      const modal = this.$buefy.modal.open({
        width: "100%",
        modalClass: "custom-modal",
        ...historyTransportPopup,
        props: {
        item: this.items[index],
        indexCompany: indexCompany,
        store: this.$store
      }
      });
  },
  openEditBaseFeePopup(index) {
    const modal = this.$buefy.modal.open({
      ...editBasePriceFeePopup,
      props: {
        item: this.items[index],
        token: this.$store.state.accessTokenJPC
      }
    });
    modal.$on('close', () => this.searchDataAllFee(index))
  },
  openEditCustomerFeePopup(index) {
    const modal = this.$buefy.modal.open({
      ...editCustomerFeePopup,
      props: {
        item: this.items[index],
        token: this.$store.state.accessTokenJPC
      }
    });
    modal.$on('close', () => this.searchDataAllFee(index))
  },
  clearDataField(index) {
    this.items[index].transportFromId = '';
    this.items[index].transportFromName = '';
    this.items[index].transportToId = '';
    this.items[index].transportToName = '';
    this.items[index].yardCity1 = '';
    this.items[index].transportToPhone = '';
    this.items[index].handlingCompanyJp = '';
    this.items[index].handlingCompanyEn = '';
    this.items[index].transportFromAddress = '';
    this.items[index].transportToIncharge = '';
    this.items[index].customerId = '';
    this.items[index].customerIdSearch = '';
    this.items[index].customerName = '';
    this.items[index].customerGradeName = '';
    this.items[index].customerGradeFee = '';
    this.items[index].customerAdjustFee = '';
    this.items[index].customerTotalFee = '';
    this.items[index].placeId = '';
    this.items[index].satelliteId = '';
    this.items[index].yardId = '';
    this.items[index].errCustomer = '';
    this.items[index].msgCustomer = '';
    this.items[index].errAuction = '';
    this.items[index].msgAuction = '';
    this.items[index].errYard = '';
    this.items[index].msgYard = '';
    this.items[index].dataFee = {};
    this.items[index].checkDataBlank = false;
    this.items[index].checkPriceCustomer = false;
    this.items[index].factorRank= 0;
    this.items[index].shippingFeeCoefficient = 1;
    this.items[index].customerGradeFeeAndPlace = '';
  },
  formatNumber(value) {
    return Math.round(value);
  },
  filteredAuctionSiteList(index) {
    const searchValue = this.items[index].transportFromName.toUpperCase() || "";

    if (this.items[index].isSearchAuction === 0) {
      return this.auctions.filter(option =>
        option.E_AuctionAreaSatellite.value.toUpperCase().includes(searchValue)
      );
    } else {
      return this.yards.filter(option =>
        option.AREA_NAME.value.toUpperCase().includes(searchValue)
      );
    }
  }
},
computed: {
  // filteredAuctionSiteList() {
  //     return (index) => (this.items[index].isSearchAuction === 0 ? this.auctions : this.yards).filter(
  //       (option) =>
  //         (this.items[index].isSearchAuction === 0 ? option.E_AuctionAreaSatellite.value : option.AREA_NAME.value)
  //           .toUpperCase()
  //           .indexOf(this.items[index].transportFromName.toUpperCase()) >= 0
  //     );
  // },
  filteredYardVendors() {
    return (index) => this.yards.filter(
      (option) =>
        option.AREA_NAME.value
          .toUpperCase()
          .indexOf(this.items[index].transportToId.toUpperCase()) >= 0
    );
  },
  filteredCustomer() {
    return (index) => this.listCustomerInf.filter(
      (option) =>
        option.customer_id_format
          .toUpperCase()
          .indexOf(this.items[index].customerId.toUpperCase()) >= 0
    );
  },
  filteredYardCity1List() {
    return (index) => this.listYardCity1.filter(
      (option) =>
        option.Yard_City_Name
        .toUpperCase()
          .indexOf(this.items[index].yardCity1.toUpperCase()) >= 0
    );
  }
}
};
</script>

<style>
.group-search {
  border: 0 !important;
}

.group-data-fee {
  display: flex;
  width: 100%;
  gap: 3%;
  margin-left: 2%;
}

.inland-fee {
  width: 30%;
}

.base-fee {
  width: 22%;
}

.customer-fee {
  width: 25%;
}

.fee-control table {
  width: 100%;
}

.fee-control table tr th {
  height: 30px;
  border: 1px solid #b5b5b5;
  text-align: center;
  line-height: 2.5;
  width: 20%;
}

.fee-control table tr td {
  text-align: center;
  border: 1px solid #b5b5b5;
  height: 30px;
  line-height: 2;
  font-size: 0.85rem;
}

.border-blank {
  border: none !important;
}

.btn-show-popup {
  margin-top: 4px;
  background-color: #ef8016;
  border-radius: 4px;
  border: 1px solid #ef8016;
  cursor: pointer;
  color: #ffffff;
}

.btn-show-popup:hover {
  background-color: #ffffff;
  color: #ef8016;
}

.btn-history {
  margin-top: 4px;
  background-color: #57d245;
  border-radius: 4px;
  border: 1px solid #57d245;
  cursor: pointer;
  color: #ffffff;
}

.btn-history:hover {
  background-color: #ffffff;
  color: #57d245;
}

.border-blank button {
  margin-top: 4px;
  background-color: #ef8016;
  border-radius: 4px;
  border: 1px solid #ef8016;
  cursor: pointer;
  color: #ffffff;
}

.border-blank button:hover {
  background-color: #ffffff;
  color: #ef8016;
}

.btn-edit-data:not(:disabled) {
  background-color: #ef8016;
  border-radius: 4px;
  border: 1px solid #ef8016;
  cursor: pointer;
  color: #ffffff;
}

.btn-edit-data:not(:disabled):hover {
  background-color: #ffffff;
  color: #ef8016;
}

.container {
  margin-bottom: 20px;
  padding: 0px !important;
  max-width: 1644px !important;
}

.column {
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  padding: 0.5rem 0.75rem !important;
}

.index {
  margin-left: -9px;
  line-height: 3;
  font-weight: 600
}

.group-button-search {
  width: 80%;
}

.group-button-search .is-grouped-multiline {
  display: flex;
  justify-content: space-between !important;
  padding-left: 12px;
}

.customs-price input {
  background-color: red !important;
  color: #ffffff !important;
  font-weight: 600 !important;
}
.custom-modal{
  max-width: 80%;
  width: 80%;
  margin: auto;
}
.recipe-price{
  margin-left: 22%;
  font-weight: 600;
  width: 100%;
  margin-bottom: 10px;
}
.field:not(:last-child) {
  margin-bottom: 0.75rem !important;
}
.group-search-content {
  margin: 10px 0px 15px 25px !important;
}
</style>